import HeroBannerSecondary from 'component/HeroBannerSecondary'
import { HeroBannerSecondaryProps } from 'component/HeroBannerSecondary/HeroBannerSecondary.types'
import { HeroBannerSecondaryContainerProps } from './HeroBannerSecondaryContainer.types'
import { StyledContainer } from './styles'
import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'

const HeroBannerSecondaryContainer = ({
  props
}: HeroBannerSecondaryContainerProps) => {
  const styleProps = useStyleMaps(props.styleMap)
  const heroProps = {
    ...props,
    des: <SafeHtmlContent html={props.des} />,
    complement: <SafeHtmlContent html={props.complement} />
  } as HeroBannerSecondaryProps
  return (
    <StyledContainer id={props.anchorIdentifier} style={styleProps}>
      <HeroBannerSecondary {...heroProps} />
    </StyledContainer>
  )
}

export default HeroBannerSecondaryContainer
